import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/work_activities',
    name: 'WorkActivity',
    component: {
      name: 'AdminWorkActivity',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'work_activity',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminWorkActivityIndex',
        component: () => import('../views/WorkActivitiesAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminWorkActivityNew',
        component: () => import('../views/WorkActivityAdminInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminWorkActivityIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminWorkActivityShow',
        component: () => import('../views/WorkActivityAdminShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminWorkActivityIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminWorkActivityDetails',
            component: () => import('../views/WorkActivityAdminDetails.vue'),
            meta: {
              backRoute: { name: 'AdminWorkActivityIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminWorkActivityEdit',
            component: () => import('../views/WorkActivityAdminInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminWorkActivityDetails' },
            },
          },
        ],
      },
    ],
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));
